export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/20e765fe22790b7f1075e229233d4cab.svg";